// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"e5381483","453":"91a1c658"}[chunkId] + ".chunk.js";
};